<template>
    <div class="header-loading">
        <div class="height d-none d-md-flex align-items-center justify-content-lg-center pl-3 pl-lg-0">
            <div class="avatar-image height d-flex align-items-center justify-content-center">
                <b-skeleton
                    v-if="hasAvatar"
                    type="avatar"
                    width="50px"
                    height="50px"
                />
            </div>
            <b-skeleton
                width="332px"
                type="button"
            />
            <div class="get-started height d-flex align-items-center justify-content-center">
                <b-skeleton
                    width="145px"
                    type="text"
                />
            </div>
        </div>
    </div>
</template>

<script>
import './HeaderLoading.scss';

export default {
    name: "HeaderLoading",
    props: {
        hasAvatar: {
            type: Boolean,
            default: false
        }
    }
};
</script>
